import { PaymentType } from '@/features/graphql/generated/graphql'
import { NotificationType } from '@/features/notifications/notification-service-extension-shared/constants/app'
import { DeliveryTypeCategory, Phase, State } from '@/features/orders/constants/app'
import { PrintJobType, PrintType, ReceiptType } from '@/features/print/constants'
import { channels } from '@/translations/resources/cs/partials/channels'
import { deliveryTypeCategories } from '@/translations/resources/cs/partials/deliveryTypeCategories'
import { notificationTypes } from '@/translations/resources/cs/partials/notificationTypes'

export default {
    ordersMap: {
        title: 'Mapa',
        open: 'Otevřít mapu',
        venue: 'Provozovna',
        loading: 'Načítání mapy',
    },
    accessibilityLabels: {
        buttons: {
            reload: 'Znovu načíst',
        },
    },

    actions: {
        apply: 'Potvrdit',
        back: 'Zpět',
        cancel: 'Storno',
        close: 'Zavřít',
        confirm: 'Potvrdit',
        continue: 'Pokračovat',
        delete: 'Smazat',
        restart: 'Restartovat',
        retry: 'Zkusit znovu',
        save: 'Uložit',
        yes: 'Ano',
        no: 'Ne',
    },

    errors: {
        errorHappenedTitle: 'Došlo k chybě!',
        missingNetworkConnection: 'Nepodařilo se navázat spojení s internetem',
        somethingBroken: 'Ups! Něco se pokazilo',
        tryRestartApp: 'Nastala neočekávaná chyba. Zkuste prosím restartovat aplikaci.',
    },

    serverError: 'Nepodařilo se navázat spojení se serverem, zkuste to prosím znovu',
    unexpectedError: 'Vyskytla se neočekávaná chyba',

    authScreensDeviceAuthorization: 'Autorizace zařízení',

    licenceVerificationScreenEnterLicenceId: 'Zadejte ID licence',
    licenceVerificationScreenLicenceId: 'ID licence',
    licenceVerificationScreenEntityNotFound: 'Licenci se nepodařilo najít, zkontrolujte zadané ID',

    deviceAuthorizationScreenEnterCode: 'Zadejte kód pro autorizaci zařízení',
    deviceAuthorizationScreenChangeLicenceId: 'Změnit ID licence',
    deviceAuthorizationScreenErrorNotGranted:
        'Autorizační kód není platný. Zkuste to, prosím, znovu.',

    profileScreensLogin: 'Přihlášení',

    profileSelectionScreenSelectProfile: 'Vyberte účet pro přihlášení',
    profileSelectionScreenChangeLicence: 'Změnit licenci',
    profileSelectionScreenEmptyListMessage: 'Nejsou žádné profily',

    profilePinScreenEnterPin: 'Zadejte PIN k vybranému účtu',
    profilePinScreenSelectAnotherAccount: 'Zvolit jiný účet',
    profilePinScreenInvalidClientError: {
        title: 'Neplatná autorizace zařízení',
        message:
            'Autorizace zařízení není platná nebo selhala. Prosím, proveďte autorizaci zařízení znovu.',
    },
    profilePinScreenInvalidGrantError: 'Přihlášení se nezdařilo. Zkuste to prosím znovu.',

    drawerItem: {
        orders: 'Objednávky',
        pos: 'Pokladna',
        phone: 'Telefon',
        openTabs: 'Otevřené účty',
        archive: 'Vyřízené',
        shiftCloseouts: 'Uzávěrky',
        settings: 'Nastavení',
    },

    shiftCloseouts: {
        overviewTitle: 'Uzávěrka',
        title: 'Denní uzávěrka',
        create: {
            openOrdersDescription:
                'Je možné, že máte rozpracované objednávky, které nebudou do uzávěrky zahrnuty. Opravdu ji chcete vytvořit?',
            readyDescription: 'Všechny objednávky jsou vyřízené. Můžete bez obav provést uzávěrku.',
            action: 'Provést uzávěrku',
            confirmation: 'Opravdu si přejete provést uzávěrku?',
            submit: 'Potvrdit uzávěrku',
        },
        overview: {
            heading: 'Přehled',
            totalSales: 'Celková tržba',
            difference: 'Rozdíl',
        },
        handover: {
            heading: 'Odvod hotovosti a stravenek',
            label: 'Hotovost + stravenky',
        },
        paymentMethods: {
            heading: 'Platební metody',
            empty: 'Uzávěrka neobsahuje žádné platby.',
            paymentType: {
                [PaymentType.CardOnsite]: 'Kartou při převzetí',
                [PaymentType.Cash]: 'Hotovost',
                [PaymentType.Invoice]: 'Faktury',
                [PaymentType.MealVoucher]: 'Stravenky',
                [PaymentType.MealVoucherCard]: 'Stravenkové karty',
                [PaymentType.Online]: 'Online platby',
            },
            automatic: 'Automaticky',
            expected: 'Očekáváno: {{amount}}',
            actualAmount: 'Skutečná částka – {{paymentMethod}}',
            balancedAmount: '{{paymentMethod}}: bez rozdílu',
            differenceAmount: '{{paymentMethod}}: rozdíl {{amount}}',
            missingAmount: '{{paymentMethod}}: skutečná částka není vyplněna',
        },
        reconciliation: {
            balanced: 'Bez rozdílu',
            incomplete: 'Vyplňte skutečné částky',
            mismatch: 'Rozdíly v platebních metodách',
            shortage: 'Manko: {{amount}}',
            surplus: 'Přebytek: {{amount}}',
        },
        history: {
            heading: 'Posledních 5 uzávěrek',
            empty: 'Zatím nebyla vytvořena žádná uzávěrka.',
            date: 'Datum',
            shiftCloseout: 'Uzávěrka',
            author: 'Autor',
            revenue: 'Tržba',
            createdBy: 'Vystavil',
            reprint: 'Vytisknout',
        },
        cashTransactions: {
            title: 'Hotovostní transakce',
            heading: 'Hotovostní transakce',
            description: 'Zadejte vklad nebo výběr hotovosti z pokladny.',
            action: 'Hotovostní transakce',
            addHeading: 'Přidat transakci',
            deposits: 'Vklady do pokladny',
            withdrawals: 'Výběry z pokladny',
            deposit: 'Vklad do pokladny',
            withdrawal: 'Výběr z pokladny',
            depositNoteLabel: 'Popis vkladu',
            withdrawalNoteLabel: 'Popis výběru',
            depositAmountLabel: 'Částka vkladu',
            withdrawalAmountLabel: 'Částka výběru',
            confirmDeposit: 'Potvrdit vklad',
            confirmWithdrawal: 'Potvrdit výběr',
            historyHeading: 'Historie transakcí',
            empty: 'Dnes zatím neproběhly žádné transakce.',
            summary: {
                deposits: 'Vklady',
                difference: 'Rozdíl',
                withdrawals: 'Výběry',
            },
        },
    },

    openTabs: {
        loading: 'Načítání účtů',
        navigation: {
            closedAccounts: 'Vyřízené účty',
        },
        accountList: {
            tabs: {
                open: 'OTEVŘENÉ',
                closed: 'VYŘÍZENÉ',
            },
            overview: {
                open: 'PŘEHLED OTEVŘENÝCH ÚČTŮ',
                closed: 'PŘEHLED VYŘÍZENÝCH ÚČTŮ',
                total: 'CELKEM',
            },
            paymentCount_one: '{{count}} platba',
            paymentCount_few: '{{count}} platby',
            paymentCount_other: '{{count}} plateb',
            state: {
                open: 'K zaplacení',
                closed: 'Zaplaceno',
            },
            create: 'VYTVOŘIT ÚČET',
        },
        account: {
            opened: 'Otevřený účet',
            closed: 'Vyřízený účet',
        },
        quantity: {
            pieces: '{{count}} ks',
        },
        detail: {
            items: 'Položky účtu',
            history: 'Historie',
            orderHistory: 'Historie účtu',
        },
        order: {
            title: 'Objednávka {{number}}',
        },
        history: {
            created: 'Účet vytvořen',
            orderAdded_one: 'Přiobjednávka · {{count}} položka',
            orderAdded_few: 'Přiobjednávka · {{count}} položky',
            orderAdded_other: 'Přiobjednávka · {{count}} položek',
            payment: 'Platba · {{method}}',
            paymentMethod: {
                [PaymentType.Cash]: 'hotově',
                [PaymentType.CardOnsite]: 'kartou',
                [PaymentType.MealVoucher]: 'stravenkami',
                [PaymentType.MealVoucherCard]: 'stravenkovou kartou',
                other: 'jinak',
            },
            closed: 'Účet vyřízen',
        },
        time: {
            elapsedMinutes: '{{count}} min',
            elapsedHours: '{{count}}h',
        },
        createAccount: {
            title: 'Vytvořit účet',
            nameLabel: 'Název účtu (nepovinné)',
            namePlaceholder: 'Název účtu',
            defaultName: 'Účet',
            confirm: 'POTVRDIT',
        },
        renameAccount: {
            title: 'Upravit účet',
            confirm: 'ULOŽIT',
        },
        catalog: {
            searchAccessibilityLabel: 'Vyhledat produkt',
            clearSearchAccessibilityLabel: 'Vymazat hledání',
            emptySearch: 'Nebyly nalezeny žádné produkty.',
        },
        cart: {
            editItem: 'Upravit položku',
            removeItem: 'Odebrat položku',
            decreaseQuantity: 'Snížit množství',
            increaseQuantity: 'Zvýšit množství',
        },
        actions: {
            confirm: 'Potvrdit',
            continue: 'Pokračovat',
            sendToKitchen: 'Do kuchyně',
            retry: 'Zkusit znovu',
            payAndFinish: 'Zaplatit a dokončit',
            cancel: 'Zrušit',
            closeDetail: 'Zavřít detail účtu',
            collapseFooter: 'Sbalit rozpis ceny',
            expandFooter: 'Rozbalit rozpis ceny',
            reprint: 'BON',
            addOrder: 'PŘIOBJEDNÁVKA',
            split: 'ROZDĚLIT',
            payAll: 'ZAPLATIT VŠE',
            rename: 'Upravit účet',
        },
        summary: {
            total: 'Celkem',
        },
        empty: {
            windowTitle: 'Okno je prázdné.',
            windowDescription: 'Vyberte účet vlevo nebo vytvořte nový.',
            accountTitle: 'Účet je prázdný.',
            accountDescription: 'Pro přidání produktů zvolte +\u00a0Přiobjednávka',
            catalogDescription: 'Vyberte produkt z menu.',
            historyTitle: 'Historie je prázdná.',
            historyDescription: 'Zatím zde nejsou žádné události.',
            splitTitle: 'Účet pro platbu je prázdný.',
            splitDescription: 'Vyberte produkty, které chcete zaplatit.',
        },
        split: {
            title: 'Rozdělení účtu',
            orderItems: 'Položky účtu',
            toPay: 'K zaplacení',
            moveToPayment: 'Přidat k zaplacení: {{item}}',
            moveFromPayment: 'Odebrat z platby: {{item}}',
        },
        payment: {
            emptyTitle: 'Účet pro platbu je prázdný.',
            emptyDescription: 'Vraťte se na účet a zvolte Zaplatit vše.',
            options: 'Další možnosti',
            calculator: 'Kalkulačka',
            reviewSelection: 'Zpět k výběru',
            cancelTitle: 'Zrušit výběr pro placení?',
            cancelConfirm: 'Ano',
            cancelKeep: 'Ne',
            paymentType: {
                [PaymentType.Cash]: 'HOTOVOST',
                [PaymentType.CardOnsite]: 'KARTOU',
                [PaymentType.MealVoucher]: 'STRAVENKY',
                [PaymentType.MealVoucherCard]: 'STRAVENKOVÁ KARTA',
            },
            more: 'VÍCE...',
            less: 'MÉNĚ...',
            confirm: 'POTVRDIT PLATBU',
            backspace: 'Smazat poslední číslici',
            totalDue: 'K zaplacení',
            remainingDue: 'Zbývá zaplatit',
            changeDue: 'K vrácení',
            receivedAmount: 'Přijatá částka',
            methodsUnavailable: 'Pro tento účet není dostupný žádný podporovaný způsob platby.',
            accountUnavailable:
                'Údaje účtu nejsou dostupné. Vraťte se na přehled a zkuste to znovu.',
            failed: 'Platbu se nepodařilo dokončit. Zkontrolujte účet a zkuste to znovu.',
        },
        feedback: {
            refreshFailed: 'Údaje účtu se nepodařilo obnovit. Před další úpravou je načtěte znovu.',
            accountChangedTitle: 'Účet se změnil',
            accountChangedMessage:
                'Účet se mezitím změnil. Zkontrolujte položky a částku a zkuste platbu znovu.',
        },
    },

    ordersList: {
        section: {
            [Phase.New]: 'Nové',
            [Phase.InProgress]: 'V kuchyni',
            [Phase.Future]: 'Budoucí',
        },
    },

    order: {
        channel: channels,
        deliveryTypeCategory: deliveryTypeCategories,
        paymentType: {
            [PaymentType.CardOnsite]: 'Kartou při převzetí',
            [PaymentType.Cash]: 'Hotově',
            [PaymentType.Invoice]: 'Fakturou',
            [PaymentType.MealVoucher]: 'Stravenkami',
            [PaymentType.MealVoucherCard]: 'Stravenkovou kartou',
            [PaymentType.Online]: 'Kartou online',
        },
        paymentStatus: {
            paid: 'Zaplaceno',
        },
        detail: {
            items: 'Položky objednávky',
            itemHeader: 'Položka',
            quantityHeader: 'Ks',
            priceHeader: 'Cena',
            priceItemsLabel: 'Cena za produkty',
            priceContainersLabel: 'Cena za obaly',
            priceDeliveryLabel: 'Dopravné',
            priceTotalLabel: 'Celkem',
            historyTitle: 'Historie objednávky',
            history: {
                actor: {
                    terminalUserProfile: 'obsluha',
                    customer: 'zákazník',
                    driver: 'řidič',
                },
                activity: {
                    paid: 'Zaplaceno',
                    cancelled: 'Storno',
                    created: 'Vytvořena objednávka',
                    accepted: 'Přijata',
                    acceptedWithShift: 'Přijata, nový čas',
                    sentToProduction: 'Odesláno do kuchyně',
                    ready: 'Připraveno k výdeji',
                    delivering: 'Na cestě',
                    delivered: 'Doručeno',
                },
            },
            showHistory: 'Zobrazit historii objednávky',
            acceptationCustomTimeTitle: 'Vlastní čas',
            requiredTime: 'Požadovaný čas',
            customTime: 'Vlastní',
            postpone: 'Odložít',
            acceptPostpone: 'Potvrdit odložení',
            toProduction: 'Do kuchyně',
            postponeTitle:
                'Objednávka se přesune zpět do sekce Nové v určený čas před zbývajícím časem doručení.',
            customPostponeTitle: 'Vrátit do sekce Nové před časem doručení',
            toReady: 'K výdeji',
            toDelivered: 'Předáno',
            toDelivering: 'Na cestě',
            cancel: 'Storno',
            accept: 'Příjmout',
            cancelDialog: {
                optionsFormTitle: 'Storno objednávky',
                noteFormTitle: 'Vložit poznámku',
                reasonLabel: 'Kdo stornuje',
                noteLabel: 'Poznámka',
                customerReason: 'Zákazník',
                restaurantReason: 'Restaurace',
                returnMoneyLabel: 'Vrátit platbu',
                confirmAction: 'Potvrdit',
                cancelAction: 'Zrušit storno',
                insertNote: 'Vložit poznámku',
                noteFormPlaceholder: 'Toto je text poznámky',
            },
            accepted: 'Přijato',
            cancelled: 'Stornováno',
            action: {
                reprint: 'Dotisk',
            },
            reprintModal: {
                result: {
                    printFailureTitle: 'Chyba při tisku',
                    printPartialSuccessMessage:
                        'Některé tiskárny dokončily tisk, u ostatních došlo k chybě.',
                    printTotalFailureMessage: 'Tisk selhal na všech dostupných tiskárnách.',
                },
            },
        },
        deliveryTime: {
            asap: 'Do {{ time }}',
            unknown: 'Neznámý typ času doručeni',
        },
        state: {
            [State.AwaitingAcceptance]: 'K přijetí',
            [State.Accepted]: 'Přijato',
            [State.Production]: 'V kuchyni',
            [State.Ready]: 'K výdeji',
            [`${State.Ready}_for_delivery`]: 'K doručení',
            [State.Delivering]: 'Na cestě',
            [State.Delivered]: 'Vyřízeno',
            [State.Cancelled]: 'Storno',
        },
        countdown: {
            delayed: 'Zpoždění',
            deliveryTypeCategory: {
                [DeliveryTypeCategory.Delivery]: 'K doručení',
                [DeliveryTypeCategory.Takeaway]: 'K předání',
                [DeliveryTypeCategory.EatIn]: 'K předání',
            },
        },
    },

    timeUnit: {
        hour: 'hod',
        min: 'min',
        shortHour: 'h',
        shortMin: 'm',
        day: '(1)[den];(2-4)[dny];(5-inf)[dnů];',
        shortMonth: 'měs.',
        shortYear: 'r.',
    },

    customer: {
        daysFromLastOrder: '{{ days }} d',
    },

    date: {
        today: 'Dnes',
        yesterday: 'Včera',
        daysAgo: 'Před {{ days }} dny',
        monthAgo: 'Před měsícem',
        monthsAgo: 'Před {{ months }} měsíci',
        moreThanAYearAgo: 'Před více než rokem',
    },

    cancelDialog: {
        title: 'Důvod storna',
        noOption: 'Nejsou k dispozici žádné důvody storna',
    },

    ordersTabs: {
        all: 'Vše',
    },

    posTabs: {
        all: 'Vše',
    },

    phoneTabs: {
        all: 'Vše',
    },

    archiveTabs: {
        all: 'Vše',
    },

    notification: {
        type: notificationTypes,
        title: {
            [NotificationType.PostponedOrder]: 'Aktualizace objednávky',
        },
        description: {
            [NotificationType.PostponedOrder]:
                'Vypršel čas odložení objednávky {{ orderShortCode }}',
        },
    },

    notificationCenter: {
        heading: 'Události',
    },

    pos: {
        customerProfile: {
            heading: 'Profil zákazníka',
            formField: {
                phone: {
                    label: 'Telefon',
                    placeholder: 'Telefon',
                    dialCodeSearch: 'Hledat',
                    invalid: 'Neplatné telefonní číslo',
                },
                name: {
                    label: 'Jméno zákazníka',
                    placeholder: 'Jméno zákazníka',
                },
                address: {
                    label: 'Adresa',
                    placeholder: 'Adresu zákazníka',
                    availability: {
                        notValidated: 'Je nutné ověřit celou adresu',
                        available: 'Na adresu doručujeme, zóna: {{ zone }}',
                        unavailable: 'Na adresu nedoručujeme',
                    },
                },
            },
        },
        productCatalog: {
            containers: 'Obaly',
            variant_few: 'varianty',
            variant_other: 'variant',
        },
        productConfiguration: {
            decreaseQuantity: 'Snížit množství',
            increaseQuantity: 'Zvýšit množství, aktuálně {{ quantity }}',
        },
        optionGroup: {
            selectionRule: {
                exact_one: 'Vyberte {{ count }} možnost',
                exact_few: 'Vyberte {{ count }} možnosti',
                exact_other: 'Vyberte {{ count }} možností',

                atLeast_one: 'Vyberte aspoň {{ count }} možnost',
                atLeast_few: 'Vyberte aspoň {{ count }} možnosti',
                atLeast_other: 'Vyberte aspoň {{ count }} možností',

                upTo_one: 'Vyberte si až {{ count }} možnost',
                upTo_few: 'Vyberte si až {{ count }} možnosti',
                upTo_other: 'Vyberte si až {{ count }} možností',

                atLeastAndUpTo_one: 'Vyberte si {{ minQuantity }} až {{ count }} možnost',
                atLeastAndUpTo_few: 'Vyberte si {{ minQuantity }} až {{ count }} možnosti',
                atLeastAndUpTo_other: 'Vyberte si {{ minQuantity }} až {{ count }} možností',
            },
            variantSelection: 'Výběr varianty',
            ingredientsRemoval: 'Odebrání ingrediencí',
        },
        quickChoiceModal: {
            quickChoice: 'Rychlá volba',
            actions: {
                posOrder: 'Pokladní objednávka',
                phoneOrder: 'Telefonní objednávka',
            },
        },
        orderFinalization: {
            toPay: 'K zaplacení',
            actions: {
                pay: 'Zaplatit a dokončit',
                more: 'Více...',
                less: 'Méně...',
                prepare: 'Do kuchyně',
            },
            cart: {
                emptyOrderPlaceholder: ['Objednávka je prázdná.', 'Vyberte produkt z menu.'],
                item: {
                    menuOptions: {
                        insertNote: 'Vložit poznámku',
                        editProduct: 'Editovat produkt',
                        editContainers: 'Editovat obaly',
                    },
                },
                editContainers: {
                    heading: 'Editovat obaly',
                    toRemove: 'K odstranění',
                    remove: 'Odebrat obal {{ name }}',
                    restore: 'Vrátit obal {{ name }}',
                },
                confirmDeleteItemMessage: 'Odstranit položku?',
            },
            inputs: {
                deliveryType: 'Způsob doručení',
                customer: {
                    label: 'Zákazník',
                    placeholder: 'Přidat zákazníka',
                },
                deliveryTime: {
                    label: 'Čas doručení',
                    daySelectorLabel: 'Datum',
                    timeSelectorLabel: 'Čas',
                },
                requiredFieldsMissing: 'Vyplňte povinná pole',
            },
            confirmCancelOrderMessage: 'Zrušit objednávku?',
        },
        customerLookupModal: {
            heading: 'Profil zákazníka',
            fields: {
                search: {
                    label: 'Telefon',
                    placeholder: 'Zadejte číslo',
                },
                name: {
                    label: 'Jméno zákazníka',
                    placeholder: 'Zadejte jméno',
                },
                address: {
                    label: 'Adresa',
                    placeholder: 'Zadej adresu zákazníka',
                },
            },
            actions: {
                cancel: 'ZRUŠIT',
                save: 'ULOŽIT',
                searchNewCustomer: 'VYHLEDAT NOVÉHO ZÁKAZNÍKA',
            },
            emptyState: {
                title: 'Vyhledejte zákazníka',
                subtitle: 'Zadejte telefonní číslo',
            },
            results: {
                addressesFromLastOrders: 'Řazeno podle poslední objednávky',
                addressesTitle: 'Nalezené adresy',
                currentAddress: 'Aktuální adresa',
                customersTitle: 'Navrhovaní zákazníci',
                name: 'JMÉNO',
                noAddresses: 'Žádné adresy',
                noCustomers: 'Žádní zákazníci',
                phone: 'TELEFON',
            },
        },
        searchProduct: 'Vyhledat produkt',
        suggestedProducts: 'Doporučené produkty',
    },

    printTypes: {
        [PrintType.DeliveryTickets]: 'Rozvozový lístek',
        [PrintType.KitchenBons]: 'Kuchyňský bon',
        [PrintType.Receipts]: 'Účtenka pro zákazníka',
        [PrintType.ShiftCloseouts]: 'Uzávěrka',
    },

    printJobTypes: {
        [PrintJobType.DeliveryTicket]: 'Rozvozový lístek',
        [PrintJobType.KitchenBon]: 'Kuchyňský bon',
        [PrintJobType.Receipt]: 'Účtenka pro zákazníka',
        [PrintJobType.OpenTabSubmissionBon]: 'Kuchyňský bon otevřeného účtu',
        [PrintJobType.ShiftCloseout]: 'Uzávěrka',
    },

    receiptTypes: {
        [ReceiptType.Original]: 'Účtenka',
        [ReceiptType.Cancellation]: 'Stornoúčtenka',
    },

    settings: {
        general: {
            heading: 'O aplikaci',
            section: {
                licence: 'Licence',
                support: 'Technická podpora',
                appVersion: 'Verze aplikace',
            },
            field: {
                businessName: 'Název podniku:',
                licenceId: 'ID licence:',
                operator: 'Provozovatel:',
                phone: 'Telefon:',
                email: 'E-mail:',
                appVersion: 'Verze aplikace:',
            },
        },
        printers: {
            addPrinterModal: {
                heading: 'Přidat novou tiskárnu',
                description: 'Vyberte typ připojení a vyhledejte dostupné tiskárny',
                field: {
                    connectionType: {
                        label: 'Typ připojení',
                        options: {
                            network: 'LAN / Wi-Fi',
                            sunmiDefault: 'Výchozí tiskárna Sunmi',
                        },
                    },
                    ipAddress: { label: 'IP adresa' },
                },
            },
            printerConfiguration: {
                backToOverview: 'Zpět na přehled',
                field: {
                    charsPerLine: {
                        label: 'Počet znaků na řádku',
                    },
                    name: {
                        label: 'Interní název',
                    },
                    paperWidth: {
                        label: 'Šířka papíru',
                        unit: 'mm',
                    },
                    printTypes: {
                        label: 'Typy tisku',
                    },
                    withDiacritics: {
                        label: 'Tisknout s diakritikou',
                    },
                },
                heading: 'Nastavení tiskárny',
                saveSettings: 'Uložit nastavení',
                testPrint: {
                    label: 'Vytisknout testovací lístek',
                    failure: 'Při tisknutí nastala chyba (kód: {{code}}).',
                },
            },
            printManagement: {
                addPrinter: 'Přidat tiskárnu',
                heading: 'Nastavení tiskáren',
                noName: 'Bez názvu',
                noPrinters: {
                    heading: 'Žádné tiskárny',
                    description: 'Zatím nemáte přidané žádné tiskárny. Začněte přidáním tiskárny.',
                },
                printer: 'Tiskárna',
                printerSettings: 'Nastavení tiskárny',
            },
        },
        notifications: {
            soundNotification: 'Zvuková signalizace',
            field: {
                orderAwaitingAcceptance: {
                    label: 'Objednávka čeká na přijetí',
                    description: 'Upozorní na každou objednávku čekající na přijetí.',
                },
                orderAccepted: {
                    label: 'Přijatá objednávka',
                    description: 'Upozorní na každou nově přijatou objednávku.',
                },
            },
        },
    },

    settingsTabs: {
        general: 'Obecné',
        notifications: 'Notifikace',
        printers: 'Správa tiskáren a tisku',
    },

    common: {
        insertNoteFormContent: {
            inputPlaceholder: 'Toto je text poznámky',
            insertNote: 'Vložit poznámku',
            note: 'Poznámka',
        },
        overview: {
            containerNameFallback: 'Obal',
            containers: 'Obaly:',
            header: 'Položky objednávky',
            quantityUnit: 'ks',
            summary: 'Shrnutí',
            prices: {
                items: 'Celkem za produkty',
                container: 'Celkem za obaly',
                delivery: 'Dopravné',
                smallOrderSurcharge: 'Příplatek za malou objednávku',
                tip: 'Spropitné',
                total: 'Celkem',
            },
        },
    },

    freeOfCharge: 'Zdarma',

    orders: {
        deliveryTypeCategory: {
            [DeliveryTypeCategory.Delivery]: 'Rozvoz',
            [DeliveryTypeCategory.EatIn]: 'Na místě',
            [DeliveryTypeCategory.Takeaway]: 'Osobní odběr',
        },
        paymentType: {
            [PaymentType.CardOnsite]: 'Kartou',
            [PaymentType.Cash]: 'Hotovost',
            [PaymentType.Invoice]: 'Fakturou',
            [PaymentType.MealVoucher]: 'Stravenky',
            [PaymentType.MealVoucherCard]: 'Stravenková karta',
            [PaymentType.Online]: 'Kartou online',
        },
    },

    form: {
        requiredFieldLabel: 'Povinné',
        requiredFieldError: '* Povinné',
    },

    dayLabels: {
        today: 'Dnes',
        tomorrow: 'Zítra',
    },

    auth: {
        logOut: 'Odhlásit se',
        profileActiveSessionScreenChoice: 'Jste přihlášen. Můžete pokračovat nebo se odhlásit.',
        changeLicenceModal: {
            title: 'Změnit licenci?',
            descriptionPrefix: 'Změnou licence odpojíte toto zařízení od restaurace',
        },
    },
}
